import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import CustomerSearch from '../../search/CustomerSearch';

export default props => {
  return <FormInputTagsItem {...props} inputComponent={CustomerSearch} />;
};
